import { Button, Flex, IconButton, Spacing } from '@billy/design-system'
import { TFunction } from 'i18next'
import { Controller } from 'react-hook-form'

import { useFormContext } from '../../../../../../../../../hooks/useForm'
import { VatSuggestionsFormSchema } from '../../../utils/formSchema'

interface AcceptRejectButtonsProps {
  rowId: string
  onReviewedChange: (rowId: string, checked: boolean) => void
  track: (event: string) => void
  t: TFunction
}

export const AcceptRejectButtons = ({ rowId, onReviewedChange, track, t }: AcceptRejectButtonsProps) => {
  const { control, setValue, getValues } = useFormContext<VatSuggestionsFormSchema>()

  const handleAccept = (currentValue: boolean) => {
    const newValue = !currentValue
    setValue(`${rowId}.isApproved`, newValue)
    if (newValue) {
      setValue(`${rowId}.isRejected`, false)
      track('VAT Single Suggestion Approved (Client)')
    }
    onReviewedChange(rowId, newValue || getValues(`${rowId}.isRejected`))
  }

  const handleReject = (currentValue: boolean) => {
    const newValue = !currentValue
    setValue(`${rowId}.isRejected`, newValue)
    if (newValue) {
      setValue(`${rowId}.isApproved`, false)
      track('VAT Single Suggestion Reviewed (Client)')
    }
    onReviewedChange(rowId, getValues(`${rowId}.isApproved`) || newValue)
  }

  return (
    <div className="exclude-opacity">
      <Flex alignItems="center" justifyContent="center" gap={Spacing.S8}>
        <Controller
          control={control}
          name={`${rowId}.isRejected`}
          defaultValue={false}
          render={({ field: { value } }) =>
            value === true ? (
              <Button
                variant="filled"
                color="danger"
                size="md"
                onClick={() => handleReject(value)}
                icon="x"
                fullRound
              ></Button>
            ) : (
              <IconButton variant="outlined" size="md" onClick={() => handleReject(value)} icon="x"></IconButton>
            )
          }
        />
        <Controller
          control={control}
          name={`${rowId}.isApproved`}
          defaultValue={false}
          render={({ field: { value } }) =>
            value === true ? (
              <Button
                variant="filled"
                color="success"
                size="md"
                onClick={() => handleAccept(value)}
                icon="check"
                fullRound
              ></Button>
            ) : (
              <IconButton variant="outlined" size="md" onClick={() => handleAccept(value)} icon="check"></IconButton>
            )
          }
        />
      </Flex>
    </div>
  )
}
